<template lang="pug">
  
  v-app#app(v-if="authenticated")
    main-menu(ref="menu")
    notifications-list(v-if="authenticated" ref="notifications")

    v-app-bar(app dense fixed clipped-left clipped-right height="60px")
      div(v-if="routes.main")
        v-app-bar-nav-icon(@click.stop="toggleMenu")
        v-divider(vertical)
      v-spacer
      v-toolbar-title(@click="$router.push('/')" :style='{cursor: "pointer"}') {{ $options.title }}
      v-spacer
      user-menu(v-if="authenticated")
      //- v-btn(icon @click="switchTheme"): v-icon invert_colors
      notification-badge(v-if="authenticated" @click="$refs.notifications.visible = !$refs.notifications.visible")

    v-snackbar(v-model="showNotification" right :timeout="2000")
      v-layout(v-if="notification")
        v-avatar: img(src="/images/notification-icon.png")
        v-list-item-content.pl-3
          v-list-item-title {{ notification.title ? notification.title : notification.body || notification.text }}
          v-list-item-subtitle(v-if="notification.title") {{ notification.body || notification.text }}
      v-btn(icon text @click="notification=null"): v-icon(small) close

    v-content
      //- v-alert(v-if="notify" :value="notify" :type="notify.type" dismissible transition="fade-transition") {{ notify.text }}
      v-snackbar(
        v-model="snackbar"
        :color="notify.type"
        :timeout="6000"
        :class="{ clickable: !!notify.task_id }"
      )
        span(@click="snackBarClick(notify)")
          v-icon.mr-2 {{ notify.icon }}
          | {{ notify.text }}
        v-btn(text icon @click="snackbar = null"): v-icon cancel
      router-view
    
    v-footer.pa-3(fixed app)
      v-spacer
      div &copy; {{ new Date().getFullYear() }}

</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import MainMenu from './components/MainMenu'
import UserMenu from './components/UserMenu'
import NotificationBadge from './components/notifications/Badge'
import NotificationsList from './components/notifications/List'

export default {

  components: {
    MainMenu,
    UserMenu,
    NotificationBadge,
    NotificationsList,
  },

  data() {
    return {
      snackbar: null,
      notificationQueue: [],
      notification: undefined,
    }
  },

  computed: {
    ...mapGetters([
      'notify',
    ]),
    ...mapGetters('auth', [
      'authenticated',
      'routes',
      'dark',
    ]),
    hasNotificationsPending() {
      return this.notificationQueue.length > 0
    },
    showNotification: {
      get() {
        return !!this.notification
      },
      set(show) {
        if(!show) this.notification = null
      }
    },
  },

  watch: {
    dark(dark) {
      this.$vuetify.theme.dark = dark
    },
    notify(notify) {
      this.snackbar = { ...notify }
    },
    $route(to) {
      if(to.path == '/logout') {
        this.logout()
      }
    },
  },

  created () {
    this.$vuetify.theme.dark = this.dark
  },

  methods: {
    ...mapActions([
      'init',
    ]),
    ...mapActions('auth', [
      'logout',
      // 'switchTheme',
    ]),
    ...mapActions('entities/notifications', [
      'markAsRead',
    ]),
    snackBarClick(item) {
      this.snackbar = null

      if(item.task_id){
        this.markAsRead(item)
        if(item.action != 'deleted') {
          if(this.$route.name == 'traffic' && this.$route.params.task == item.task_id) return
          this.$router.push({
            name: 'traffic',
            params: {
              task: item.task_id
            }
          })
        }
      }
    },
    toggleMenu() {
      this.$refs.menu.visible = !this.$refs.menu.visible
    },
  }
}
</script>


<style lang="sass">
.v-application--wrap
  overflow: hidden
  > .v-toolbar.theme--dark
    background-color: #212121
  > .v-toolbar .v-toolbar__content, .v-toolbar__extension
    padding-left: 0

.v-snack .white
  &, .v-icon
    color: #000
</style>
